<template>
    <div>
        <section v-if="mode === null" class="bank-id-choice">
            <b-button block variant="outline-primary" @click="handleMode('bankid')">
                <div class="bank-id-logo">
                    <bank-id-icon style="display: flex; height: 24px;" fill="#041e3a"></bank-id-icon>
                    Logga in med BankID
                </div>
            </b-button>
        </section>
        <section class="bank-id-container" v-if="orderReference && mode === 'bankid'">
            <bank-id-icon class="bank-id-logo-container" style="display: flex; height: 64px;" fill="#041e3a"></bank-id-icon>
            <img v-if="payload.qrCode" :src="payload.qrCode" :alt="payload.message" class="qr-code-img"/>
            <div v-else class="qr-code-img placeholder">
                <b-spinner small/>
                {{ $t('bankid.waitingOnSession') }}
            </div>
            <b-button v-if="payload.qrCode" class="bank-id-button" variant="outline-primary" :href="appUrl">{{ $t('bankid.openApp') }}</b-button>
            <div class="bank-id-message" v-if="payload.message">{{ payload.message }}</div>
        </section>
        <div v-if="payload.bankIdStatus === 'error'">
            <b-alert show variant="danger">
                {{ payload.message }}
            </b-alert>
        </div>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
import HttpClient from '@services/HttpClient';
import BankIdIcon from '@components/Icons/BankIdIcon.vue';
import { useAppStore } from '@stores/App';

export default defineComponent({
    components: { BankIdIcon },
    beforeUnmount() {
        this.clear();
    },
    data() {
        const app = useAppStore();
        const platform = app.platform;
        const mobile = platform === 'iOS' || platform === 'Android';

        return {
            appUrl: null,
            app,
            user: null,
            orderReference: null,
            polling: false,
            pollingId: null,
            pollingPending: false,
            mode: null,
            platform,
            mobile,
            payload: {
                bankIdStatus: null,
                qrCode: null,
                hintCode: null,
                message: null,
            },
        };
    },
    methods: {
        init() {
            HttpClient.getData('/auth/bankid/authenticate')
                .then((res) => res.json())
                .then((jsonResponse) => {
                    if ([ 'error', 'fail' ].includes(jsonResponse.status)) {
                        this.payload.bankIdStatus = jsonResponse.status;
                        this.payload.message = jsonResponse.message;
                        return;
                    }
                    this.orderReference = jsonResponse.data.orderRef;
                    this.poll();
                });
        },
        clear() {
            clearInterval(this.pollingId);
            this.polling = false;
            this.payload = {
                bankIdStatus: null,
                qrCode: null,
                hintCode: null,
                message: '',
            };
        },
        poll() {
            this.clear();

            if (!this.orderReference) {
                return;
            }

            this.pollingId = setInterval(() => {
                if (this.pollingPending === false) {
                    this.pollingPending = true;
                    HttpClient.getData(`/auth/bankid/status/${this.orderReference}`).then((res) => {
                        return res.json();
                    }).then((json) => {
                        this.appUrl = `bankid:///?autostarttoken=${json.autoStartToken}&redirect=null`;

                        if (json.status !== 'success') {
                            this.clear();
                            this.payload.message = json.message;
                            return;
                        }

                        this.payload = {
                            bankIdStatus: json.data.bankIDStatus,
                            qrCode: json.qrCode,
                            hintCode: json.data.hintCode,
                            message: json.message,
                            autoStartLink: json.autoStartLink,
                        };

                        if (this.payload.bankIdStatus === 'complete') {
                            this.user = json.data.user;
                            this.token = json.data.token;
                            this.orderReference = null;
                            this.clear();

                            const data = json.data;
                            this.handleUpdate({ user: data.user, auth: data.auth });
                        }
                    }).finally(() => {
                        this.pollingPending = false;
                    });
                }
            }, 1000);
        },
        handleMode(mode) {
            this.mode = mode;
            this.init();
            this.$emit('started', event);
        },
        handleUpdate(event) {
            this.$emit('update', event);
        },
    },
});
</script>
<style lang="scss" scoped>
.bank-id-choice {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.bank-id-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 2rem 0;
    gap: 1rem;
}

.bank-id-message {
    background: black;
    padding: 1rem;
    color: white;
    max-width: 340px;
    width: 100%;
}

.bank-id-button {
    max-width: 340px;
    width: 100%;
}

.bank-id-logo {
    display: flex;
    gap: 8px;
    margin: auto;
    justify-content: center;

    svg {
        height: 24px;
    }

    button:hover & svg, button:hover & :deep(.st0) {
        fill: white !important;
    }
}

.bank-id-logo-container {
    border-bottom: 1px solid #f0f0f0;
    width: 100%;
}

.qr-code-img {
    width: 100%;
    height: 100%;
    max-width: 200px;
    max-height: 200px;

    &.placeholder {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 1rem;
        width: 200px;
        height: 200px;
        aspect-ratio: 1;
        background: transparent;
    }
}

:deep(.btn) {
    border-radius: 0;
}

img {
    width: 100%;
    height: auto;
}
</style>
